import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IResolveExceptionProps } from './IResolveExceptionProps';
import { ResolveExceptionModal } from './ResolveExceptionModal';

export const ResolveExceptionExecutor = createActivityModalExecutor<IResolveExceptionProps>({
    modal: ResolveExceptionModal,
    defaultModalSize: 'xl',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        activityId: getActivityIdFromCompositeId(objId),
        actionKey: action.key,
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
